import { render, staticRenderFns } from "./hospitaLlist.vue?vue&type=template&id=45e3b34c&scoped=true"
import script from "./hospitaLlist.vue?vue&type=script&lang=js"
export * from "./hospitaLlist.vue?vue&type=script&lang=js"
import style0 from "./hospitaLlist.vue?vue&type=style&index=0&id=45e3b34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e3b34c",
  null
  
)

export default component.exports